import { useEffect, useRef, useState } from "react";

import GuestImg     from "../../assets/images/conversations/ep-24-dhawal-khullar-guest.webp";
import ThumbImg     from "../../assets/images/conversations/024.webp";
import PlayIcon     from "../../assets/icons/conversations/play-icon.svg";
import FacebookIcon from "../../assets/icons/conversations/facebook.svg";
import LinkedinIcon from "../../assets/icons/conversations/linkedin.svg";
import TwitterIcon  from "../../assets/icons/conversations/twitter.svg";

/* ─────────────────────────────────────────────
   PREFIX: dk2-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .dk2-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .dk2-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ── HERO ── */
  .dk2-hero { padding-top: 60px; padding-bottom: 60px; }
  .dk2-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .dk2-hero__left { display: flex; flex-direction: column; gap: 34px; }
  .dk2-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .dk2-hero__title.dk2-visible { opacity: 1; transform: translateY(0); }

  /* ── SOCIAL SHARE BUTTONS ── */
  .dk2-hero__social {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.08s, transform 0.7s ease 0.08s;
  }
  .dk2-hero__social.dk2-visible { opacity: 1; transform: translateY(0); }
  .dk2-hero__social a {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    padding: 10px 14px;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    text-decoration: none;
    transition: opacity 0.2s ease;
  }
  .dk2-hero__social a:hover { opacity: 0.85; }
  .dk2-hero__social a.fb { background: #3B5998; }
  .dk2-hero__social a.li { background: #0077B5; }
  .dk2-hero__social a.tw { background: #1DA1F2; }
  .dk2-hero__social a img { width: 18px; height: 18px; flex-shrink: 0; }

  .dk2-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .dk2-hero__spotify.dk2-visible { opacity: 1; transform: translateY(0); }
  .dk2-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .dk2-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .dk2-hero__right.dk2-visible { opacity: 1; transform: translateY(0); }

  /* ── YOUTUBE THUMB ── */
  .dk2-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .dk2-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .dk2-yt-thumb:hover img { opacity: 0.85; }
  .dk2-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .dk2-yt-thumb__play img { width: 40px; height: 44px; }
  .dk2-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .dk2-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ── BODY ── */
  .dk2-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .dk2-body.dk2-visible { opacity: 1; transform: translateY(0); }
  .dk2-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .dk2-body__para:last-child { margin-bottom: 0; }

  /* ── GUEST ── */
  .dk2-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .dk2-guest.dk2-visible { opacity: 1; transform: translateY(0); }
  .dk2-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .dk2-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .dk2-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .dk2-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .dk2-inner { padding-left: 32px; padding-right: 32px; }
    .dk2-hero { padding-top: 32px; padding-bottom: 48px; }
    .dk2-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .dk2-hero__title { font-size: 24px; }
    .dk2-hero__left { gap: 16px; }
    .dk2-hero__social { gap: 10px; }
    .dk2-hero__social a { gap: 10px; font-size: 12px; padding: 10px 12px; }
    .dk2-guest__title { font-size: 24px; margin-bottom: 24px; }
    .dk2-guest__photo-bg { width: 260px; height: 300px; }
    .dk2-guest__name { font-size: 24px; margin-top: 18px; }
    .dk2-body__para { font-size: 14px; margin-bottom: 12px; }
    .dk2-body { padding-bottom: 48px; }
    .dk2-guest { padding-bottom: 48px; }
    .dk2-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .dk2-inner { padding-left: 16px; padding-right: 16px; }
    .dk2-hero { padding-top: 51px; padding-bottom: 30px; }
    .dk2-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .dk2-hero__left { gap: 30px; }
    .dk2-hero__title { font-size: 30px; }
    .dk2-hero__social { gap: 11px; }
    .dk2-hero__social a { gap: 10px; font-size: 15px; padding: 10px 14px; }
    .dk2-body__para { font-size: 16px; margin-bottom: 10px; }
    .dk2-guest__title { font-size: 30px; margin-bottom: 20px; text-align:left;}
    .dk2-guest__photo-bg { width: 100%; height: 386px; }
    .dk2-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .dk2-body { padding-bottom: 30px; }
    .dk2-guest { padding-bottom: 30px; }
    .dk2-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("dk2-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "REPLACE_EP24_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="dk2-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 24 Dhawal Khullar Pravaig Dynamics"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div
      className="dk2-yt-thumb"
      onClick={() => setPlaying(true)}
      role="button"
      aria-label="Play video"
    >
      <img src={ThumbImg} alt="EP 24 Dhawal Khullar thumbnail" />
      <div className="dk2-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const socialRef  = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(socialRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="dk2-hero">
      <div className="dk2-inner">
        <div className="dk2-hero__grid">
          <div className="dk2-hero__left">
            <div ref={titleRef} className="dk2-hero__title">
              EP 24 | Building India's First Homegrown Premium Electric Car | Pravaig Dynamics | Dhawal KHULLAR
            </div>
            <div ref={socialRef} className="dk2-hero__social">
              <a href="https://www.facebook.com/sharer/sharer.php?u=" className="fb" target="_blank" rel="noreferrer">
                <img src={FacebookIcon} alt="Facebook" /> Facebook
              </a>
              <a href="https://www.linkedin.com/sharing/share-offsite/?url=" className="li" target="_blank" rel="noreferrer">
                <img src={LinkedinIcon} alt="LinkedIn" /> Linked in
              </a>
              <a href="https://twitter.com/intent/tweet?url=" className="tw" target="_blank" rel="noreferrer">
                <img src={TwitterIcon} alt="Twitter" /> Twitter
              </a>
            </div>
            <div ref={spotifyRef} className="dk2-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/0062F4GACEfmIrTNlhS07t?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 24 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="dk2-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="dk2-body">
      <div className="dk2-inner">
        <p className="dk2-body__para">
          In this episode, we go back to the OEM sector, but we examine electric cars from a very different and unique perspective as we are featuring a bold and adventurous company that is designing an Indian-made premium EV that will only be available to luxury hotels and tourism fleets. The company is also designing and will manufacture its own battery packs.
        </p>
        <p className="dk2-body__para">
          Already funded by Groupe Eren of France, their first batch of 2,500 limited edition cars will only be available in Bangalore and Delhi as a start. The car is said to be powered by a single electric motor, that it claims will go from 0-100 km/hr in 5.4 seconds. Energized by a 96-kWh battery pack which it says will have a range of 500 km. We speak today with Dhawal Khullar, Co-founder &amp; CTO of Pravaig Dynamics.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="dk2-guest">
      <div className="dk2-inner">
        <h2 className="dk2-guest__title">Our Guest</h2>
        <div>
          <div className="dk2-guest__photo-bg">
            <img src={GuestImg} alt="Dhawal Khullar" />
          </div>
          <p className="dk2-guest__name">Dhawal KHULLAR</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep24DhawalKhullar() {
  return (
    <>
      <style>{CSS}</style>
      <div className="dk2-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}